import { BorderAll } from "@mui/icons-material";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const columns = [
  {
    id: "world",
    title: "Dunyo bo'yicha",
    is_span: true,
    z_index: 0,
  },
  {
    id: "olds",
    title: "Yoshi kattalar",
    is_span: true,
    z_index: 0,
  },
  {
    id: "youngs",
    title: "Yoshi kichiklar",
    is_span: true,
    z_index: 0,
  },
  {
    id: "women_old",
    title: "Ayollar",
    is_span: true,
    z_index: 1,
    parent_id: "olds",
  },
  {
    id: "men_old",
    title: "Erkaklar",
    is_span: true,
    z_index: 1,
    parent_id: "olds",
  },
  {
    id: "girls_young",
    title: "Qizlar",
    is_span: false,
    z_index: 1,
    parent_id: "youngs",
  },
  {
    id: "guys_young",
    title: "Bollar",
    is_span: false,
    z_index: 1,
    parent_id: "youngs",
  },
  {
    id: "girls_young",
    title: "Qizlar 2",
    is_span: false,
    z_index: 1,
    parent_id: "youngs",
  },
  {
    id: "guys_young",
    title: "Bollar 2",
    is_span: false,
    z_index: 1,
    parent_id: "youngs",
  },
  {
    id: "women_married",
    title: "Turmushga chiqqan Ayollar",
    is_span: false,
    z_index: 2,
    parent_id: "women_old",
  },
  {
    id: "women_not_married",
    title: "Turmushga chiqmagan Ayollar",
    is_span: false,
    z_index: 2,
    parent_id: "women_old",
  },
  {
    id: "men_married",
    title: "Turmushga chiqqan Erkaklar",
    is_span: false,
    z_index: 2,
    parent_id: "men_old",
  },
  {
    id: "men_not_married",
    title: "Turmushga chiqmagan Erkaklar",
    is_span: false,
    z_index: 2,
    parent_id: "men_old",
  },

  {
    id: "four",
    title: "to'rtinchisi",
    is_span: false,
    z_index: 3,
    parent_id: "men_not_married",
  },
  {
    id: "besh",
    title: "beshinchisi",
    is_span: false,
    z_index: 3,
    parent_id: "men_not_married",
  },

  {
    id: "qiziqishga1",
    title: "qiziqishga 1",
    is_span: false,
    z_index: 4,
    parent_id: "four",
  },
  {
    id: "qiziqishga2",
    title: "qiziqishga 2",
    is_span: false,
    z_index: 4,
    parent_id: "four",
  },
];

function findLastRelatedArrays(columns: any, id: any) {
  const relatedArrays: any[] = [];

  function findRelatedArraysRecursively(currentId: any) {
    const relatedItems = columns.filter(
      (column: any) => column.parent_id === currentId
    );
    relatedArrays.push(...relatedItems);
    relatedItems.forEach((item: any) => findRelatedArraysRecursively(item.id));
  }

  findRelatedArraysRecursively(id);

  return relatedArrays.filter(
    (item) => !columns.some((column: any) => column.parent_id === item.id)
  );
}

function hasRelatedArrays(columns: any[], id: any): boolean {
  return columns.some((column: any) => column.parent_id === id);
}

const maxZIndex = columns.reduce((max, column) => {
  return Math.max(max, column.z_index);
}, -Infinity);

export default function TablePage() {
  return (
    <Container>
      <TableContainer component={Paper}>
        <Table aria-label="spanning table">
          <TableHead>
            {Array.from({ length: maxZIndex + 1 }, (_, index) => index).map(
              (i) => (
                <TableRow>
                  {columns
                    .filter((column) => column.z_index === i)
                    .map((column) => {
                      let colSpan = findLastRelatedArrays(columns, column.id);
                      let rowSpan = hasRelatedArrays(columns, column.id);
                      console.log(`#${column.title}`, rowSpan);

                      return (
                        <TableCell
                          style={{
                            borderRight: "1px solid rgb(224, 224, 224)",
                          }}
                          align={column.is_span === true ? "center" : "left"}
                          colSpan={colSpan.length}
                          rowSpan={
                            rowSpan ? undefined : maxZIndex + 1 - column.z_index
                          }
                        >
                          {column.title}
                        </TableCell>
                      );
                    })}
                </TableRow>
              )
            )}
          </TableHead>
          <TableBody></TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
